import extractErrorMessage from '../utils/extractErrorMessage';
import { publicClient } from './client';

export const fetchMunicipalities = async () => {
  try {
    const response = await publicClient.get(`/districts`);
    return { data: response.data, error: null };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri dobavljanju okruga.'
    );
    return { data: null, error: message };
  }
};

export const fetchCities = async (municipalityName) => {
  try {
    const response = await publicClient.get(`/districts/${municipalityName}`);
    return { data: response.data, error: null };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      `Došlo je do greške pri dobavljanju gradova okruga ${municipalityName}.`
    );
    return { data: null, error: message };
  }
};
